<!--
    描述： 项目统计
    创建时间： 2022-03-21 14:52:46
    作者： Wang Shuai
    邮箱： 591372242@qq.com
-->
<template>
	<div class="filter-layout">
		<div class="filter-box pdt10">
			<template v-if="filterShow">
				<el-form :model="searchForm"
						 label-width="120px"
						 size="small"
						 ref="searchForm">
					<el-row v-if="curType == 1">
						<el-col :span="8">
							<el-form-item label="片区"
										  prop="selectArea"
										  label-width="90px">
								<div class="time-box">
									<span :key="item.id"
										  class="text-overflow"
										  v-for="item in northList"
										  :class="{ 'active-time': selectArea == item.value }"
										  @click="searchClick(item, 'selectArea')">
										{{ item.sname }}
									</span>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="计划编排类别"
										  prop="layoutType">
								<div class="time-box">
									<span :key="item.id"
										  class="text-overflow"
										  v-for="item in typeOptions"
										  :class="{ 'active-time': searchForm.layoutType == item.value }"
										  @click="searchClick(item, 'layoutType')">
										{{ item.sname }}
									</span>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="进展状况"
										  prop="scheduleStatus">
								<div class="time-box">
									<span :key="item.id"
										  v-for="item in stateOptions"
										  :class="{ 'active-time': searchForm.scheduleStatus == item.value }"
										  @click="searchClick(item, 'scheduleStatus')">
										{{ item.label }}
									</span>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col v-if="curType == 1"
								:span="8">
							<el-form-item label="建设类型"
										  prop="constructionType"
										  label-width="90px">
								<div class="time-box sp-box">
									<span :key="item.id"
										  class="text-overflow"
										  v-for="item in typeList('dxjslx')"
										  :class="{ 'active-time': searchForm.constructionType == item.value }"
										  @click="searchClick(item, 'constructionType')">
										{{ item.sname }}
									</span>
								</div>
							</el-form-item>
						</el-col>
						<el-col v-if="curType != 2"
								:span="8">
							<el-form-item label="时间维度"
										  prop="selectDateType">
								<div class="custom-box">
									<span :key="item.id"
										  class="text-overflow"
										  v-for="(item, index) in timeOptions"
										  :class="{ 'active-span': activeTimeBtn === index }"
										  @click="changeDateType(item, index)">
										{{ item.label }}
									</span>
								</div>
							</el-form-item>
						</el-col>
						<el-col v-if="curType != 2"
								:span="8">
							<!-- 按月份 -->
							<template v-if="activeTimeBtn === 0">
								<el-form-item label="选择月份"
											  prop="time">
									<el-date-picker v-model="searchForm.time"
													type="monthrange"
													@change="monthChange($event, 'month')"
													range-separator="~"
													start-placeholder="开始月份"
													end-placeholder="结束月份"
													value-format="yyyy-MM">
									</el-date-picker>
								</el-form-item>
							</template>
							<!-- 按季度 -->
							<template v-if="activeTimeBtn === 1">
								<el-form-item label="选择季度"
											  prop="time">
									<div class="flex">
										<el-select v-model="searchForm.startDate"
												   placeholder="开始季度"
												   clearable
												   @change="quarterChange($event, 'start')">
											<el-option v-for="item in quarterList"
													   :key="'start' + item.id"
													   :label="item.year + '年' + item.quarter + '季度'"
													   :value="item.quarterStartTime">
											</el-option>
										</el-select>
										<span class="ml5 mr5">~</span>
										<el-select v-model="searchForm.endDate"
												   placeholder="结束季度"
												   clearable
												   @change="quarterChange($event, 'end')">
											<el-option v-for="item in quarterList"
													   :key="'end' + item.id"
													   :label="item.year + '年' + item.quarter + '季度'"
													   :value="item.quarterEndTime">
											</el-option>
										</el-select>
									</div>
								</el-form-item>
							</template>
							<!-- 按年份 -->
							<template v-if="activeTimeBtn === 2">
								<el-form-item label="选择年份"
											  prop="time">
									<div class="flex">
										<el-date-picker v-model="searchForm.startDate"
														type="year"
														placeholder="开始年份"
														value-format="yyyy"
														@change="yearChange($event, 'start')">
										</el-date-picker>
										<span class="ml5 mr5">~</span>
										<el-date-picker v-model="searchForm.endDate"
														type="year"
														placeholder="结束年份"
														value-format="yyyy"
														@change="yearChange($event, 'end')">
										</el-date-picker>
									</div>
								</el-form-item>
							</template>
						</el-col>

						<el-col v-if="curType == 1"
								:span="8">
							<el-form-item label="项目名称"
										  prop="sname"
										  label-width="90px">
								<el-input v-model="searchForm.sname"
										  placeholder="请输入"
										  clearable></el-input>
							</el-form-item>
						</el-col>
						<el-col v-if="curType == 1"
								:span="8">
							<el-form-item label="项目类型"
										  prop="proType">
								<el-select v-model="searchForm.proType"
										   clearable>
									<el-option v-for="(item, index) in projectDict.dxxmlx"
											   :key="'proYear' + index"
											   :label="item.sname"
											   :value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col v-if="curType == 1"
								:span="8">
							<el-form-item label="建设单位"
										  prop="constructionUnit">
								<el-select v-model="searchForm.constructionUnit"
										   clearable>
									<el-option v-for="(item, index) in unitList"
											   :key="'constructionUnit' + index"
											   :label="item.sname"
											   :value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<!-- 折柱图的查询条件 -->
						<el-col v-if="curType == 2"
								:span="6">
							<el-form-item label="选择年份"
										  prop="year">
								<el-date-picker v-model="lineSearchForm.year"
												type="year"
												placeholder="选择年"
												size="small"
												value-format="yyyy"
												format="yyyy年"
												:clearable="false">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col v-if="curType == 2"
								:span="10">
							<el-form-item label="产值"
										  prop="moduleType">
								<div class="time-box">
									<span class="text-overflow"
										  v-for="(item, index) in outputOptions"
										  :key="item.index"
										  :class="{ 'active-time': selectModuleType == item.value }"
										  @click="searchClick(item, 'selectModuleType')">
										{{ item.sname }}
									</span>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="curType == 1 ? 24 : 8"
								class="text-right mb10">
							<el-button size="small"
									   icon="el-icon-search"
									   type="primary"
									   @click="getTableData">查询</el-button>
							<el-button size="small"
									   icon="el-icon-refresh"
									   @click="doRefresh">重置</el-button>
						</el-col>
					</el-row>

				</el-form>
			</template>

			<!-- 筛选折叠按钮 -->
			<div class="control-btn"
				 @click="filterShow = !filterShow">
				<span v-if="filterShow">
					点击收起
					<svg-icon icon-class="pack-up"
							  class="c-icon ml5"></svg-icon>
				</span>
				<span v-else>筛选
					<svg-icon icon-class="pack-down"
							  class="c-icon ml5"></svg-icon>
				</span>
			</div>
		</div>

		<div class="filter-content overflow-hidden">
			<h2 v-if="curType == 1"
				class="content-header">东部新中心建设项目产值统计报表</h2>
			<h2 v-else
				class="content-header">
				东部新中心建设项目{{curType == 2 ? selectModuleName : curType == 3 ? '产值' : ''}}统计图
				<el-tooltip placement="bottom-start"
							effect="light"
							style="width: 20px; height: 20px; vertical-align: text-top;">
					<div slot="content">
						<p>数据统计说明：默认展示本年度月份数据统计，当选择其他年月</p>
						<p class="mt5">数据时，则展示其他年度数据统计。</p>
						<p class="mt10">本年度项目：有计划开竣工时间，且时间范围在本年度的，无实</p>
						<p class="mt5">际竣工时间都纳入本年度项目统计。</p>
						<p class="mt5">有计划开竣工时间，且实际竣工时间为本年度的，本年纳入统</p>
						<p class="mt5">计，第二年不统计。</p>
						</p>
					</div>
					<svg-icon class="ml5"
							  icon-class="wenhao"></svg-icon>
				</el-tooltip>
			</h2>

			<div class="content-subtitle">
				<div class="left">
					<el-radio-group v-model="curType"
									@change="changeChartType"
									size="small">
						<el-radio-button :label="1">表格</el-radio-button>
						<el-radio-button :label="2">柱状图/折线图</el-radio-button>
						<el-radio-button :label="3">饼状图</el-radio-button>
					</el-radio-group>
					<span v-if="curType != 2"
						  class="ml20 custom-text">统计时间： {{ tableObj.rangeTime }}</span>
					<span v-else
						  class="ml20 custom-text">统计时间： {{ rangeTimeLine }}</span>
				</div>

				<div class="right">
					<span class="custom-text">单位：</span>
					<el-radio-group v-model="searchForm.isMillion"
									size="small"
									@change="getTableData">
						<el-radio-button label="1">元</el-radio-button>
						<el-radio-button label="2">万元</el-radio-button>
					</el-radio-group>

					<template v-if="curType == 1">
						<el-button size="small"
								   class="ml10"
								   icon="el-icon-menu"
								   type="primary"
								   @click="doFilter">列过滤</el-button>
						<el-button @click="exportExcelMethod()"
								   size="small">导出Excel</el-button>
					</template>
					<el-button v-else
							   @click="exportChart"
							   icon="el-icon-download"
							   class="ml10"
							   size="small">导出</el-button>
				</div>
			</div>

			<div v-if="curType == 1"
				 class="content-table">
				<vxe-table :data="tableObj.tableData"
						   align="center"
						   header-align="center"
						   height="auto"
						   auto-resize
						   border
						   :loading="tableObj.loading"
						   :row-class-name="customClass"
						   ref="projectTable"
						   highlight-current-row
						   highlight-hover-row
						   show-overflow="tooltip"
						   show-header-overflow="tooltip">
					<vxe-column field="sort"
								title="序号"
								width="70"></vxe-column>
					<vxe-column field="monName"
								title="年/月"
								width="100"></vxe-column>
					<vxe-column field="projectName"
								title="项目名称"
								width="150"
								header-align="center"
								align="left">
						<template #default="{ row }">
							<span class="blue-text vxe-cell--label"
								  @click="jumpInProject(row)">{{ row.projectName }}</span>
						</template>
					</vxe-column>
					<vxe-column field="areaName"
								title="片区"
								width="90"></vxe-column>
					<vxe-column field="layoutTypeName"
								title="计划编排类别"
								width="120"></vxe-column>
					<vxe-column field="proTypeName"
								title="项目类型"
								width="150"></vxe-column>
					<vxe-column field="constructionTypeName"
								title="建设类型"
								width="150"></vxe-column>
					<vxe-column field="address"
								title="项目位置"
								width="150"></vxe-column>
					<vxe-column field="tenantName"
								title="建设单位"
								width="150"></vxe-column>
					<vxe-column field="striveStartDate"
								title="争取开工年份"
								width="150"></vxe-column>
					<vxe-column field="planStartTime"
								title="计划开工时间"
								width="150"></vxe-column>
					<vxe-column field="planEndTime"
								title="计划竣工时间"
								width="150"></vxe-column>
					<vxe-column field="realStartDate"
								title="实际开工时间"
								width="150">
						<template #default="{ row }">
							<el-tooltip effect="dark"
										:content="row.realStartDate"
										placement="top">
								<span v-if="!!row.realStartDate">{{ row.realStartDate.substr(0, 11) }}</span>
								<span v-else>-</span>
							</el-tooltip>
						</template>
					</vxe-column>
					<vxe-column field="realEndDate"
								title="实际竣工时间"
								width="150">
						<template #default="{ row }">
							<el-tooltip effect="dark"
										:content="row.realEndDate"
										placement="top">
								<span v-if="!!row.realEndDate">{{ row.realEndDate.substr(0, 11) }}</span>
								<span v-else>-</span>
							</el-tooltip>
						</template>
					</vxe-column>
					<vxe-column field="progressStatus"
								title="进展状况"
								width="150"></vxe-column>
					<vxe-column field="packNum"
								title="标段数量"
								width="100"></vxe-column>
					<vxe-colgroup title="项目总投资"
								  header-class-name="custom-table-height">
						<vxe-column v-for="item in projectDict.dxxmtr"
									:key="item.value"
									:field="'mapList.' + item.alias"
									:title="item.sname"
									width="120"
									align="right"
									header-align="center"
									header-class-name="custom-table-height"></vxe-column>
					</vxe-colgroup>
					<vxe-colgroup title="计划"
								  header-class-name="custom-table-height">
						<vxe-column field="planCompletedOutputValue"
									title="计划完成产值"
									width="120"
									align="right"
									header-align="center"
									header-class-name="custom-table-height">
							<template #default="{ row }">
								{{ setValue(row.planCompletedOutputValue) }}
							</template>
						</vxe-column>
						<vxe-column field="planProgressPayment"
									title="计划进度款"
									width="120"
									align="right"
									header-align="center"
									header-class-name="custom-table-height">
							<template #default="{ row }">
								{{ setValue(row.planProgressPayment) }}
							</template>
						</vxe-column>
					</vxe-colgroup>
					<vxe-colgroup title="申报"
								  header-class-name="custom-table-height">
						<vxe-column field="declareCompletedOutputValue"
									title="申报完成产值"
									width="120"
									align="right"
									header-align="center"
									header-class-name="custom-table-height">
							<template #default="{ row }">
								{{ setValue(row.declareCompletedOutputValue) }}
							</template>
						</vxe-column>
						<vxe-column field="declareProgressPayment"
									title="申报进度款"
									width="120"
									align="right"
									header-align="center"
									header-class-name="custom-table-height">
							<template #default="{ row }">
								{{ setValue(row.declareProgressPayment) }}
							</template>
						</vxe-column>
					</vxe-colgroup>
					<vxe-colgroup title="审核"
								  header-class-name="custom-table-height">
						<vxe-column field="examineCompletedOutputValue"
									title="审核完成产值"
									width="120"
									align="right"
									header-align="center"
									header-class-name="custom-table-height">
							<template #default="{ row }">
								{{ setValue(row.examineCompletedOutputValue) }}
							</template>
						</vxe-column>
						<vxe-column field="examineProgressPayment"
									title="审核应付进度款"
									width="120"
									align="right"
									header-align="center"
									header-class-name="custom-table-height">
							<template #default="{ row }">
								{{ setValue(row.examineProgressPayment) }}
							</template>
						</vxe-column>
					</vxe-colgroup>
					<vxe-table-column field="actualPayment"
									  title="实际付款"
									  width="120"
									  align="right"
									  header-align="center">
						<template #default="{ row }">
							{{ setValue(row.actualPayment) }}
						</template>
					</vxe-table-column>
				</vxe-table>
			</div>

			<!-- 柱状图/折线图 -->
			<div v-else-if="curType == 2"
				 class="content-table">
				<ProjectLineChart ref="line_chart"
								  :apiParams="apiParams" />
			</div>

			<!-- 饼状图 -->
			<div v-else-if="curType == 3"
				 class="content-table">
				<ProjectPieChart ref="pie_chart"
								 :apiParams="apiParams" />
			</div>
		</div>

		<!-- 列过滤 -->
		<ColumnFilter ref="ColumnFilter"
					  v-if="showFilter"
					  :filterColumns="filterColumns"
					  :busType="busType"
					  memory
					  @onFilter="onFilter"></ColumnFilter>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import {
	getProjectData,
	getUnit,
	getProjectStatisticsQuarter,
	getProjectPieQuarter,
} from 'api/FormManager/FormManager'
import * as Api from 'api/projectManage/ProjectIndex'
import * as HomeApi from '@/api/home/homeIndex'
import ColumnFilter from '@/views/Common/ColumnFilter'
import { getContainerParams } from '@/api/home/homeIndex'
import { exportExcel } from 'utils/tools'
import ProjectLineChart from './components/ProjectLineChart'
import ProjectPieChart from './components/ProjectPieChart'

export default {
	components: { ColumnFilter, ProjectLineChart, ProjectPieChart },
	data() {
		return {
			filterShow: true,
			searchForm: {
				proYear: '',
				sname: '',
				layoutType: '1,2,3', //  1 新建项目 2 续建项目 3 开展前期
				proType: '',
				constructionType: '',
				constructionUnit: '',
				area: '',
				scheduleStatus: '',
				isMillion: '2',
				selectDateType: '1', // 时间维度 1 按月 2 按季度 3 按年
				startDate: '', // 开始时间
				endDate: '', // 结束时间
				time: [],
			},
			quarterList: [],
			currentQuarter: [],
			// 选中的时间维度
			activeTimeBtn: 0,
			selectArea: [],
			unitList: [],
			checkAll: true,
			curType: 1,
			tableObj: {
				rangeTime: '',
				tableData: [],
				loading: false,
			},
			showFilter: false, //列过滤弹窗显隐
			// 列过滤内容
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
			northList: [], //片区
			busType: '1098006',
			// 图表查询参数
			apiParams: {},
			// 折柱图
			lineSearchForm: {
				year: '',
				moduleType: '', // 产值
			},
			selectModuleType: '',
			selectModuleName: '片区产值',
			rangeTimeLine: '', // 统计时间
		}
	},
	created() {
		this.tableObj.loading = true
		this.getUnitList()
		// 获取当前时间(后台)
		this.getContainerParams()
		this._getProjectStatisticsQuarter()
		this.getSelfData('1098006')
	},
	methods: {
		// 获取当前时间(后台)
		getContainerParams() {
			getContainerParams({}).then((res) => {
				let now = res.data.currentDate
				let start = this.$utils.getWhatMonth(now, 0, 'first')
				let end = this.$utils.getWhatMonth(now, 0, 'last')
				start = this.$utils.toDateString(start, 'yyyy-MM')
				end = this.$utils.toDateString(end, 'yyyy-MM')
				this.searchForm.startDate = start
				this.searchForm.endDate = end
				this.searchForm.time = [start, end]
				this.tableObj.rangeTime = start + ' 至 ' + end

				this.northList = this.areaList()
				// 设置初始值
				this.setDefault()
				this.getTableData()
			})
		},

		// 查询季度
		_getProjectStatisticsQuarter() {
			if (this.curType == 2) {
				return
			}
			const getApi =
				this.curType == 1
					? getProjectStatisticsQuarter
					: this.curType == 3
					? getProjectPieQuarter
					: ''
			getApi({}).then((res) => {
				this.quarterList = res.data
				// 当前季度
				const obj = res.data.find((item) => item.isCurrent == 1)
				this.currentQuarter = obj
					? [obj.quarterStartTime, obj.quarterEndTime]
					: []
			})
		},

		// 获取自定义列过滤数据
		getSelfData(busType) {
			let params = { busType }
			this.tableObj.loading = true
			HomeApi.getSelfData(params)
				.then((res) => {
					if (res.data.length == 0) {
						return
					}
					if (this.$refs.projectTable) {
						let tableShowColumn =
							this.$refs.projectTable.getTableColumn()
						tableShowColumn.fullColumn.forEach((x) => {
							let obj = res.data.find(
								(y) => y.field == x.property
							)
							if (obj) {
								x.visible = obj.isChecked
							}
						})
						this.$refs.projectTable.refreshColumn()
					}
					this.tableObj.loading = false
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 点击列过滤
		doFilter() {
			let tableColumn = this.$refs.projectTable.getTableColumn()
			let filterColumn = this.$utils.clone(tableColumn.fullColumn, true)
			filterColumn.shift()
			this.filterColumns[0].columns = filterColumn
			this.showFilter = true
			setTimeout(() => {
				this.$refs.ColumnFilter.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			this.tableObj.loading = true
			if (this.$refs.projectTable) {
				// 确定赋值
				this.$set(this, 'filterColumns', arr)
				this.getSelfData('1098006')
				this.tableObj.loading = false
				return
			}
			this.tableObj.loading = false
		},

		// search 区域点击事件
		searchClick(data, type) {
			if (type == 'selectArea') {
				this.selectArea = data.value
			} else if (type == 'selectModuleType') {
				this.selectModuleType = data.value
				this.selectModuleName =
					data.sname == '全部' ? '片区产值' : data.sname
			} else {
				this.searchForm[type] = data.value
			}
			this.getTableData()
		},

		// 切换时间维度
		changeDateType(item, index) {
			this.activeTimeBtn = index
			this.searchForm.selectDateType = item.value

			const year = new Date().getFullYear() + ''
			const month = year + '-' + (new Date().getMonth() + 1)
			switch (index) {
				case 0:
					this.searchForm.startDate = month
					this.searchForm.endDate = month
					this.searchForm.time = [month, month]
					break
				case 1:
					this.searchForm.startDate =
						this.currentQuarter.length > 0
							? this.currentQuarter[0]
							: ''
					this.searchForm.endDate =
						this.currentQuarter.length > 1
							? this.currentQuarter[1]
							: ''
					this.searchForm.time = this.currentQuarter
					break
				case 2:
					this.searchForm.startDate = year
					this.searchForm.endDate = year
					this.searchForm.time = [year, year]
					break
				default:
					break
			}
			this.getTableData()
		},

		// 月份选择change
		monthChange(data, type) {
			this.searchForm.startDate = data?.[0] || ''
			this.searchForm.endDate = data?.[1] || ''
			if (data && data.length > 0) {
				this.tableObj.rangeTime = data[0] + ' 至 ' + data[1]
			} else {
				this.tableObj.rangeTime = ''
			}
		},

		// 季度选择change
		quarterChange(data, type) {
			if (data == '') {
				return
			}
			if (type == 'start') {
				let endTime = this.searchForm.endDate
				let handlerData = this.quarterList.find(
					(x) => x.quarterStartTime == data
				)
				if (endTime != '') {
					let handlerEndData = this.quarterList.find(
						(x) => x.quarterEndTime == endTime
					)
					if (handlerData.id > handlerEndData.id) {
						this.searchForm.startDate = ''
						this.$message.error('开始季度不能超过结束季度！')
					}
				}
				return
			}
			let startTime = this.searchForm.startDate
			let handlerData = this.quarterList.find(
				(x) => x.quarterEndTime == data
			)
			if (startTime != '') {
				let handlerEndData = this.quarterList.find(
					(x) => x.quarterStartTime == startTime
				)
				if (handlerData.id < handlerEndData.id) {
					this.searchForm.endDate = ''
					this.$message.error('结束季度不能小于开始季度！')
				}
			}
		},

		// 年份选择change
		yearChange(data, type) {
			if (type == 'start') {
				let endTime = this.searchForm.endDate || 0
				if (
					parseInt(data) > parseInt(endTime) &&
					parseInt(endTime) != 0
				) {
					this.searchForm.startDate = ''
					this.$message.error('开始时间不能超过结束时间！')
				}
				return
			}
			let startTime = this.searchForm.startDate || 0
			if (parseInt(data) < parseInt(startTime)) {
				this.searchForm.endDate = ''
				this.$message.error('结束时间不能小于开始时间！')
			}
		},

		// 导出excel
		exportExcelMethod() {
			let tableData = this.tableObj.tableData
			let params = {
				selectYear: this.tableObj.rangeTime, //统计时间
				excelData: tableData, //导出数据集合
				isMillion: this.searchForm.isMillion,
			}
			let baseUrl = '/auditoutputvalue/exportExcel'
			let url = process.env.VUE_APP_BASE_URL + baseUrl
			let fileName = ''
			exportExcel(url, params, fileName)
		},

		// 进入项目
		jumpInProject(data) {
			let url = this.$outUrl
			let token = this.$getSessionItem('token')
			let tenantId = this.$getSessionItem('tenantId')
			let limitId = this.$getSessionItem('limitId')
			Api.getAuditWorkPower({
				projectId: data.projectId,
			}).then((res) => {
				if (res.operationCode == 1 && res.msg == 'faild') {
					this.$message.warning(res.data)
					return
				}
				window.open(
					`${url}/DxAuditWork/#/main?projectId=${data.projectId}&token=${token}&tenantId=${tenantId}&limitId=${limitId}&isDataRole=${res.data}`,
					'_blank'
				)
			})
		},

		// 获取建设单位
		getUnitList() {
			getUnit({ limitId: '1382233551767498754' }).then((res) => {
				this.unitList = res.data.tenant
			})
		},

		// 获取数据
		getTableData() {
			switch (this.curType) {
				case 1:
					this._getProjectData()
					break
				case 2:
					this.apiParams = {
						unit:
							this.searchForm.isMillion == '1'
								? '0'
								: this.searchForm.isMillion == '2'
								? '1'
								: '',
						year: this.lineSearchForm.year,
						moduleType: this.selectModuleType,
					}
					break
				case 3:
					this.apiParams = {
						unit:
							this.searchForm.isMillion == '1'
								? '0'
								: this.searchForm.isMillion == '2'
								? '1'
								: '',
						selectDateType: this.searchForm.selectDateType,
						startDate: this.searchForm.startDate,
						endDate: this.searchForm.endDate,
					}
					break
				default:
					break
			}
		},

		// 获取表格数据
		_getProjectData() {
			this.tableObj.loading = true
			let params = this.$utils.clone(this.searchForm, true)
			params.area = this.selectArea
			delete params.time
			if (params.hasOwnProperty('year')) {
				delete params.year
			}
			if (params.hasOwnProperty('moduleType')) {
				delete params.moduleType
			}
			getProjectData(params)
				.then((res) => {
					this.tableObj.loading = false
					this.tableObj.tableData = res.data
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},

		// 选择全部片区
		handleCheckAll(val) {
			this.selectArea = val
				? this.projectDict.xmgsqy.map((x) => x.value)
				: []
		},

		// 导出图表
		exportChart() {
			switch (this.curType) {
				case 2:
					let str = `东部新中心建设项目${this.selectModuleName}统计图`
					this.$refs.line_chart.download(str)
					break
				case 3:
					this.$refs.pie_chart.download()
				default:
					break
			}
		},

		// 处理值（根据单位变化）
		setValue(value) {
			// 后台处理
			return value
		},

		// 设置初始值
		setDefault() {
			this.selectArea = this.projectDict.xmgsqy
				.map((x) => x.value)
				.join(',')
		},

		// 重置
		doRefresh() {
			this.searchForm = {
				proYear: '',
				sname: '',
				layoutType: '1,2,3', // 全部
				proType: '',
				constructionType: '',
				constructionUnit: '',
				area: '',
				scheduleStatus: '',
				isMillion: '2',
				selectDateType: '1', // 1 按月
				startDate: '',
				endDate: '',
				time: [],
			}
			this.activeTimeBtn = 0
			this.tableObj.currentPage = 1

			this.lineSearchForm = {
				year: new Date().getFullYear() + '',
				moduleType: '', // 产值
			}
			this.selectModuleType = ''
			this.selectModuleName = '片区产值'
			this.rangeTimeLine = this.lineSearchForm.year + '年'

			this._getProjectStatisticsQuarter()
			this.getContainerParams()
		},

		// 切换图表类型
		changeChartType() {
			this.doRefresh()
		},

		// 自定义行样式
		customClass({ row, rowIndex }) {
			if (rowIndex === 0) {
				return 'custom-Total1'
			}
			if (row.sort == '小计') {
				return 'custom-sTotal'
			}
		},

		areaList() {
			let all = this.projectDict.xmgsqy.map((x) => x.value)
			all = all.join(',')
			let obj = {
				sname: '全部',
				value: all,
			}
			let arr = this.$utils.clone(this.projectDict.xmgsqy, true)
			arr.unshift(obj)
			return arr
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),

		unitName() {
			return this.searchForm.isMillion === '2' ? '(万元)' : '(元)'
		},

		// 计划编排类别
		typeOptions() {
			let arr = [
				{
					sname: '全部',
					value: '1,2,3',
					id: '100099',
				},
				{
					sname: '新建项目',
					value: '1',
					id: '100086',
				},
				{
					sname: '续建项目',
					value: '2',
					id: '100088',
				},
				{
					sname: '开展前期',
					value: '3',
					id: '100087',
				},
			]
			return arr
		},

		// 进展状况
		stateOptions() {
			let arr = [
				{
					label: '全部',
					value: '',
					id: '10001',
				},
				{
					label: '未开工',
					value: '0',
					id: '10002',
				},
				{
					label: '已开工',
					value: '1',
					id: '10003',
				},
				{
					label: '竣工',
					value: '2',
					id: '10004',
				},
			]
			return arr
		},

		// list
		typeList() {
			return function (type) {
				let arr = this.$utils.clone(this.projectDict[type], true)
				let obj = {
					sname: '全部',
					value: '',
				}
				if (arr) {
					arr.unshift(obj)
				}
				return arr
			}
		},

		// 时间维度
		timeOptions() {
			let arr = [
				{
					label: '按月份',
					value: 1,
				},
				{
					label: '按季度',
					value: 2,
				},
				{
					label: '按年份',
					value: 3,
				},
			]
			return arr
		},
		// 产值
		outputOptions() {
			return [
				{ sname: '全部', value: '' },
				{ sname: '计划完成产值', value: '0' },
				{ sname: '申报完成产值', value: '1' },
				{ sname: '审核完成产值', value: '2' },
				{ sname: '实际付款', value: '3' },
			]
		},
	},
	watch: {
		searchForm: {
			handler(newVal, oldVal) {
				let text1 = ''
				let text2 = ''
				switch (this.activeTimeBtn) {
					case 0:
					case 2:
						const str =
							this.activeTimeBtn === 0
								? '月'
								: this.activeTimeBtn === 2
								? '年'
								: ''
						text1 = !!newVal.startDate ? newVal.startDate + str : ''
						text2 = !!newVal.endDate ? newVal.endDate + str : ''
						break
					case 1:
						let start = this.quarterList.find(
							(x) => x.quarterStartTime == newVal.startDate
						)
						let end = this.quarterList.find(
							(x) => x.quarterEndTime == newVal.endDate
						)
						text1 =
							newVal.startDate && start
								? start.year + '年' + start.quarter + '季度'
								: ''
						text2 =
							newVal.endDate && end
								? end.year + '年' + end.quarter + '季度'
								: ''
						break
					default:
						break
				}
				if (!!text1 || !!text2) {
					this.tableObj.rangeTime = text1 + ' 至 ' + text2
				} else {
					this.tableObj.rangeTime = ''
				}
			},
			deep: true,
		},
		'lineSearchForm.year': {
			handler(newVal) {
				if (!!newVal) {
					this.rangeTimeLine = newVal + '年'
				}
			},
		},
	},
}
</script>

<style lang="less" scoped>
.filter-row {
	display: flex;
	align-items: center;
	height: 44px;
	font-size: 14px;

	/deep/ .el-checkbox {
		margin-right: 20px;
	}
}

.content-header {
	line-height: 60px;
	text-align: center;
	padding-top: 15px;
}

.content-subtitle {
	display: flex;
	height: 45px;
	justify-content: space-between;
	align-items: center;
}

.content-table {
	height: calc(~'100% - 75px - 45px');
}
.time-box {
	display: flex;
	text-align: center;
	font-size: 12px;
	span + span {
		margin-left: 10px !important;
	}
	.active-time {
		background-color: #2cbdfc !important;
		color: #fff !important;
	}
	* {
		height: 28px !important;
		line-height: 30px !important;
		background-color: #f2f2f2;
		color: #868686;
		cursor: pointer;
		flex: 1;
	}
}
.sp-box > * {
	flex: inherit !important;
	padding: 0 13px !important;
}
.sp-box span:first-child {
	padding: 0 15px !important;
}
.custom-box {
	display: flex;
	span:hover {
		background-color: #2cbdfc;
		color: #fff;
	}
}
.custom-box > * {
	flex: 1;
	text-align: center;
	height: 28px !important;
	line-height: 28px !important;
	font-size: 12px;
	border: 1px solid #eee;
	background-color: #fff;
	color: #868686;
	cursor: pointer;
}
.active-span {
	background-color: #2cbdfc !important;
	color: #fff !important;
}
.disabled {
	cursor: not-allowed !important;
	background-color: #fafafa;
	color: #868686;
}
.disabled:hover {
	border: 1px solid #eee;
	background-color: #fafafa !important;
	color: #868686 !important;
}
.custom-text {
	font-size: 14px !important;
}
</style>
